import { Box, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState, useMemo } from 'react';
import { FixedBottomBar, HeaderBox } from './MobileBookPage';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BooksService from "../../Services/Books";
import i18n from '../../i18n';
import GeetGovindServices from "../../Services/GeetGovind";
import KalyanServices from "../../Services/Kalyan";
import KalpataruServices from "../../Services/Kalpataru";
import VivekVaniServices from "../../Services/Vivekvani"; 
import BookDetailsCard from './Common/BookDetailsCard';
import { Product } from './MobileMagazines';

const MobileReadEBooksPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [bookDetails, setBookDetails] = useState<any>(null);
    const [magazinesDetails, setMagazinesDetails] = useState<any>(null);
    const [kalyanDetails, setKalyanDetails] = useState<any>(null);
    const [vivekVaniDetails, setVivekVaniDetails] = useState<any>(null); 
    const [isLiked, setIsLiked] = useState<boolean>(false);
    const [toggleFav, setToggleFav] = useState<boolean>(false); 
    const [magazineId, setMagazineId] = useState<any>();
    const [kalyanId, setKalyanId] = useState<any>();
    const [vivekVaniBookId, setVivekVaniBookId] = useState<any>(); 
    const [totalRecords, setTotalRecords] = useState<any>();
    const [geetGovindDetails,setGeetGovindDetails]=useState<any>();
    const [geetGovindBookId,setGeetGovindBookId]=useState<any>();
    const location: any = useLocation();
    const { lang: urlLang } = useParams();
    var userid: any = localStorage.getItem('UserId');
    const isKalpataruBook = location?.state?.isKalpataruBook || false;
    const isVivekVaniBook = location?.state?.isVivekVaniBook || false; 

    useEffect(() => {
        if (location?.state?.bookId) {
            BooksService.getMobileCurrentBook(location?.state?.bookId, userid).then((res) => {
                console.log("API Response for getCurrentBook:", res);
                if (res.status) {
                    setBookDetails(res.result);
                    setIsLiked(res?.result?.isFavourite);
                } else {
                    console.error("API call failed, status is false:", res.message);
                }
            }).catch(error => {
                console.error("Error fetching book details:", error);
            });
        }
    }, [i18n.language, location?.state?.bookId, userid]);

    // Incoming magazine id from hub entry or carousel navigation (magzineId / geetGovindId)
    // geetGovindId = real monthly issue id (carousel); magzineId from hub may be a catalog id
    const detailMagazineId = location?.state?.geetGovindId;
    const incomingMagazineId = location?.state?.geetGovindId || location?.state?.magzineId;
    const magazineLanguage =
        location?.state?.magazineLanguage ||
        location?.state?.magazineLangauge ||
        location?.state?.geetGovindLang ||
        (urlLang === 'hindi' || urlLang === 'english' ? urlLang : '') ||
        '';

    const isSimpleLangLabel = (rawLang: any): boolean => {
        const lang = String(rawLang || '').toLowerCase();
        return lang === 'english' || lang === 'en' || lang === 'hindi' || lang === 'hi';
    };

    const inferGeetGovindLangLabel = (rawLang: any): string => {
        if (!rawLang && rawLang !== 0) return '';
        const lang = String(rawLang).toLowerCase();
        if (lang === 'english' || lang === 'en' || lang.includes('english') || lang.includes('angrezi')) return 'english';
        if (lang === 'hindi' || lang === 'hi' || lang.includes('hindi') || lang.includes('hin') || lang.includes('हिं') || lang.includes('हिन')) return 'hindi';
        return '';
    };

    const resolvedGeetGovindLangLabel = useMemo(() => {
        const fromState = inferGeetGovindLangLabel(
            location?.state?.geetGovindLang ||
            location?.state?.magazineLanguage ||
            location?.state?.magazineLangauge ||
            urlLang
        );
        if (fromState) return fromState;

        const fromDetails = inferGeetGovindLangLabel(
            geetGovindDetails?.monthlyMagazineLanguage ||
            magazinesDetails?.[0]?.monthlyMagazineLanguage ||
            magazinesDetails?.[0]?.magazineLanguage
        );
        if (fromDetails) return fromDetails;

        return 'hindi';
    }, [location?.state, urlLang, geetGovindDetails, magazinesDetails]);

    const resolvedMagazineLanguageId = useMemo(() => {
        const fromState = location?.state?.magazineLanguage || location?.state?.magazineLangauge || '';
        if (fromState && !isSimpleLangLabel(fromState)) return fromState;

        return geetGovindDetails?.monthlyMagazineLanguageId ||
            magazinesDetails?.[0]?.monthlyMagazineLanguageId ||
            magazinesDetails?.find((item: any) => item?.monthlyMagazineLanguageId)?.monthlyMagazineLanguageId ||
            (isSimpleLangLabel(fromState) ? fromState : '');
    }, [location?.state, geetGovindDetails, magazinesDetails]);

    const isGeetGovindContext =
        location?.state?.productType === Product.MonthlyMagazine ||
        !!incomingMagazineId ||
        urlLang === 'hindi' ||
        urlLang === 'english' ||
        (typeof location?.pathname === 'string' && location.pathname.includes('/magazines/geetgovind'));

    // Load selected magazine for TOP section by real monthly issue id (carousel geetGovindId)
    useEffect(() => {
        if (!detailMagazineId) return;

        const logdetails: string[] = [`load_top_magazine id=${detailMagazineId}`];
        setMagazineId(detailMagazineId);
        setGeetGovindBookId(detailMagazineId);

        // Desktop-proven detail API (id + lang) — avoids UserId=null failures
        GeetGovindServices.getcurrentGeetGovind(String(detailMagazineId)).then((res: any) => {
            if (res?.status && res?.result) {
                setGeetGovindDetails(res.result);
                setIsLiked(res?.result?.isFavourite);
                logdetails.push('getcurrentGeetGovind_success');
            } else {
                logdetails.push(`getcurrentGeetGovind_failed message=${res?.message}`);
                console.error("getcurrentGeetGovind failed:", res?.message);
            }
            console.log('[MobileReadEBooksPage]', logdetails.join(' | '));
        }).catch((error: any) => {
            logdetails.push(`getcurrentGeetGovind_error=${error}`);
            console.error("Error in getcurrentGeetGovind:", error);
            console.log('[MobileReadEBooksPage]', logdetails.join(' | '));
        });
    }, [detailMagazineId]);

    // Load monthly list for carousel (and fall back to first item when no id)
    useEffect(() => {
        if (!isGeetGovindContext) return;

        const logdetails: string[] = [];
        const commonParams = {
            start: 0,
            length: 67,
            categoryId: "",
            IsChildLiterature: false,
            sort: "",
            authorId: "",
            search: "",
            isSpecial: false,
        };

        logdetails.push(`load_monthly_list lang=${magazineLanguage}`);
        GeetGovindServices.getMonthlyMagazine(
            commonParams.search,
            commonParams.start,
            commonParams.length,
            commonParams.categoryId,
            commonParams.IsChildLiterature,
            commonParams.sort,
            commonParams.authorId,
            magazineLanguage,
            commonParams.isSpecial,
            "", ""
        ).then((res) => {
            console.log("API Response for getMonthlyMagazine:", res);
            if (res.status) {
                const items = res?.result?.items || [];
                setMagazinesDetails(items);
                setTotalRecords(res?.result?.totalRecords);

                // If magazine id received and found in list → select it; else first magazine
                const matched = incomingMagazineId
                    ? items.find((item: any) => String(item?.id) === String(incomingMagazineId))
                    : null;
                const resolvedId = matched?.id || items?.[0]?.id;
                if (resolvedId) {
                    setMagazineId(resolvedId);
                    // If detail API has not filled top yet, paint from list item
                    if (matched) {
                        // Keep richer detail API result when it already matches this id
                        setGeetGovindDetails((prev: any) =>
                            (prev && String(prev.id) === String(matched.id)) ? prev : matched
                        );
                    } else if (!incomingMagazineId && items[0]) {
                        setGeetGovindDetails((prev: any) => prev || items[0]);
                    }
                }
                logdetails.push(incomingMagazineId
                    ? (matched ? `selected_from_param id=${resolvedId}` : `incoming_not_in_list fallback_first id=${resolvedId}`)
                    : `fallback_first id=${resolvedId}`);
            } else {
                logdetails.push(`list_failed message=${res.message}`);
                console.error("API call failed, status is false:", res.message);
            }
            console.log('[MobileReadEBooksPage]', logdetails.join(' | '));
        }).catch(error => {
            logdetails.push(`list_error=${error}`);
            console.error("Error fetching magazine details:", error);
            console.log('[MobileReadEBooksPage]', logdetails.join(' | '));
        });
    }, [isGeetGovindContext, magazineLanguage, incomingMagazineId]);

    // Favourite flag refresh when magazineId changes and we already have list context
    useEffect(() => {
        if (!magazineId || !isGeetGovindContext) return;
        const currentUserId = localStorage.getItem('UserId') || userid || '';
        if (!currentUserId) return;

        GeetGovindServices.getcurrentMagazine(magazineId, currentUserId).then((res: any) => {
            if (res?.status) {
                setIsLiked(res?.result?.isFavourite);
                if (res?.result) {
                    setGeetGovindDetails(res.result);
                }
            }
        }).catch((error: any) => {
            console.error("Error refreshing magazine favourite:", error);
        });
    }, [magazineId, isGeetGovindContext, userid]); 
    useEffect(() => {
        if (location?.state?.kalyansId || location?.state?.kalpataruId) {
            if (isKalpataruBook ||location?.state?.kalpataruId ) {
                KalpataruServices.getKalPataruById(location?.state?.kalyansId || location?.state?.kalpataruId, userid).then((res: any) => {
                    console.log("API Response for getKalpataruById:", res);
                    if (res.status) {
                        setKalyanDetails(res.result);
                        setIsLiked(res?.result?.isFavourite);
                        setKalyanId(location?.state?.kalyansId || location?.state?.kalpataruId);
                    } else {
                        console.error("API call failed, status is false:", res.message);
                    }
                }).catch((error: any) => {
                    console.error("Error fetching Kalpataru details:", error);
                });
            } else {
                KalyanServices.getKalyansById(location?.state?.kalyansId, userid).then((res: any) => {
                    console.log("API Response for getKalyanById:", res);
                    if (res.status) {
                        setKalyanDetails(res.result);
                        setIsLiked(res?.result?.isFavourite);
                        setKalyanId(location?.state?.kalyansId);
                    } else {
                        console.error("API call failed, status is false:", res.message);
                    }
                }).catch((error: any) => {
                    console.error("Error fetching Kalyan details:", error);
                });
            }
        } 
        
        
        else if (location?.state?.vivekVaniId) { 
            VivekVaniServices.getVaniById(location?.state?.vivekVaniId, userid).then((res: any) => {
                console.log("API Response for getVivekVaniById:", res);
                if (res.status) {
                    setVivekVaniDetails(res.result);
                    setIsLiked(res?.result?.isFavourite);
                    setVivekVaniBookId(location?.state?.vivekVaniId); 
                } else {
                    console.error("API call failed, status is false:", res.message);
                }
            }).catch((error: any) => {
                console.error("Error fetching Vivek Vani details:", error);
            });
        }
        // Geet Govind detail is loaded by incomingMagazineId effect above
    }, [i18n.language, location?.state?.kalyansId, location?.state?.vivekVaniId, userid, isKalpataruBook || location?.state?.kalpataruId,location?.state?.geetGovindId]);

    const toggleLike = () => {
        if (location?.state?.bookId) {
            !isLiked
                ? BooksService.addFavourite(location?.state?.bookId).then((res: any) => {
                    console.log("Add Favourite Book Response:", res);
                    res.status && setIsLiked(true);
                })
                : BooksService.removeFavourite(location?.state?.bookId).then((res: any) => {
                    res.status && setIsLiked(false);
                });
        } else if (location?.state?.productType === Product.MonthlyMagazine && magazineId) {
            !isLiked
                ? GeetGovindServices.addMagzineFavourite(magazineId).then((res: any) => {
                    console.log("Add Favourite Magazine Response:", res);
                    res.status && setIsLiked(true);
                })
                : GeetGovindServices.removeMagzineFavourite(magazineId).then((res: any) => {
                    res.status && setIsLiked(false);
                });
        } else if (location?.state?.kalyansId && kalyanId || location?.state?.kalpataruId) {
            if (isKalpataruBook || location?.state?.kalpataruId) {
                !isLiked
                    ? KalpataruServices.addKalpatruFavourite(kalyanId || location?.state?.kalpataruId).then((res: any) => {
                        console.log("Add Favourite Kalpataru Response:", res);
                        res.status && setIsLiked(true);
                    })
                    : KalpataruServices.removeKalpatruFavourite(kalyanId || location?.state?.kalpataruId).then((res: any) => {
                        res.status && setIsLiked(false);
                    });
            } else {
                !isLiked
                    ? KalyanServices.addKalyanFavourite(kalyanId).then((res: any) => {
                        console.log("Add Favourite Kalyan Response:", res);
                        res.status && setIsLiked(true);
                    })
                    : KalyanServices.removeKalyanFavourite(kalyanId).then((res: any) => {
                        res.status && setIsLiked(false);
                    });
            }
        } else if (location?.state?.vivekVaniId && vivekVaniBookId) {
            !isLiked
                ? VivekVaniServices.addFavourite(vivekVaniBookId).then((res: any) => {
                    console.log("Add Favourite Vivek Vani Response:", res);
                    res.status && setIsLiked(true);
                })
                : VivekVaniServices.removeFavourite(vivekVaniBookId).then((res: any) => {
                    res.status && setIsLiked(false);
                });
        }
        else if (location?.state?.geetGovindId && geetGovindBookId){
            !isLiked
            ? GeetGovindServices.addMagzineFavourite(geetGovindBookId).then((res: any)=>{
                res.status && setIsLiked(true);
            })
            :
              GeetGovindServices.removeMagzineFavourite(geetGovindBookId).then((res: any)=>{
                res.status && setIsLiked(false);
              })
        }
        setToggleFav((x) => !x); 
    };

    const itemType = useMemo(() => {
        if (location?.state?.bookId) return t('itemtype_books_tr');
        if (location?.state?.geetGovindId || location?.state?.productType === Product.MonthlyMagazine || urlLang) {
            return resolvedGeetGovindLangLabel === 'english'
                ? t('itemtype_geetgovind_english_tr')
                : t('itemtype_geetgovind_hindi_tr');
        }
        if (isKalpataruBook || location?.state?.kalpataruId) return t('itemtype_kalpataru_tr');
        if (isVivekVaniBook || location?.state?.vivekVaniId) return t('itemtype_vivek_vani_tr');
        if (location?.state?.kalyansId) return t('itemtype_kalyan_tr');
        return t('itemtype_books_tr');
    }, [location?.state, t, urlLang, resolvedGeetGovindLangLabel]);
    
    return (
        <>
            <Box sx={{
                backgroundColor: "#F0F0F0",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
            }}>
                <HeaderBox>
                    <>
                        <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
                            <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
                        </IconButton>
                        <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
                            <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
                        </IconButton>
                        <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
                            {t("shrihari_tr")}
                        </Typography>
                        <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
                            {t(location?.state?.bookId
                                ? "All_Books"
                                : (location?.state?.geetGovindId || location?.state?.productType === Product.MonthlyMagazine
                                    ? (resolvedGeetGovindLangLabel === 'english'
                                        ? "itemtype_geetgovind_english_tr"
                                        : "itemtype_geetgovind_hindi_tr")
                                    : (isKalpataruBook
                                        ? "Kalpataru_lang_tr"
                                        : (isVivekVaniBook
                                            ? "Vivek_Vani_tr"
                                            : "All_Kalyans"))))}
                        </Typography>
                    </>
                </HeaderBox>
                {(bookDetails || magazinesDetails || kalyanDetails || vivekVaniDetails || geetGovindDetails) ? (
                    <BookDetailsCard
                        bookDetails={bookDetails}
                        magazinesDetails={magazinesDetails}
                        kalyanDetails={kalyanDetails}
                        vivekVaniDetails={vivekVaniDetails} 
                        geetGovindDetails={geetGovindDetails}
                        selectedMagazineId={magazineId}
                        magazineLang={resolvedGeetGovindLangLabel}
                        magazineLanguageId={resolvedMagazineLanguageId}
                        isLiked={isLiked}
                        onToggleLike={toggleLike}
                        totalRecords={totalRecords}
                        itemType={itemType}
                    />
                ) : (
                    <Typography variant="body1" sx={{ textAlign: 'center', mt: 4 }}>
                        {t("Loading details...")}
                    </Typography>
                )}

                {/* <FixedBottomBar /> */}
            </Box>
        </>
    );
}

export default MobileReadEBooksPage;
